<template>
  <div class="document-page" v-loading="isLoading">
    <div class="filter-content">
      <el-form inline>
        <el-form-item label="文档名称:">
          <el-input v-model="formValue.docName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="文档格式:">
          <el-select v-model="formValue.docType" multiple placeholder="请选择">
            <el-option
              v-for="opt in docFormatOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="getList">筛选</el-button>
    </div>
    <div class="operation-area">
      <el-button type="primary" @click="clickUploadFileBtn">上传文档</el-button>
    </div>
    <el-table class="my-table" :data="dataList" highlight-current-row @sort-change="sortChange">
      <template slot="empty">
        <!-- 没有数据 -->
        <NoData></NoData>
      </template>
      <el-table-column property="Name" label="文档名称" width="460" sortable="custom">
        <template #default="{ row }">
          <div class="table-item-content">
            <!-- <i class="el-icon-edit"></i> -->
            <img :src="mapDocType(row)" alt="" class="doc_type_icon" />
            <el-input
              v-show="row.show"
              v-model="row.prefix"
              :maxlength="100"
              @change="updateDoc(row, 'save')"
            >
              <template slot="append">{{ row.postfix }}</template>
            </el-input>
            <span
              v-show="!row.show"
              class="title"
              :title="row.Name"
              @click="updateDoc(row, 'edit')"
            >
              {{ row.Name }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="Size" label="文档大小">
        <template #default="{ row }">
          <div>
            {{ bytesToSize(row.Size) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column property="CTime" label="上传时间">
        <template #default="{ row }">
          {{ row.CTime ? $moment(row.CTime * 1000).format('YYYY/MM/DD HH:mm:ss') : '--' }}
        </template>
      </el-table-column>
      <el-table-column property="DownloadCount" label="下载次数"></el-table-column>
      <el-table-column label="操作">
        <template #default="{ row }">
          <el-button
            v-if="statusMap[row.Status] === '已上传'"
            type="text"
            @click="handleClickToDetail(row)"
          >
            查看日志
          </el-button>
          <el-button
            v-if="statusMap[row.Status] === '未上传'"
            type="text"
            @click="handleClickPreview(row)"
          >
            继续上传
          </el-button>
          <el-button @click="handleClickDownload(row)" type="text">
            {{ statusMap[row.Status] === '已上传' ? '下载' : '-' }}
          </el-button>
          <el-button @click="handleClickDelete(row)" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :current-page.sync="pagination.page_index"
      :page-size="pagination.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="g_pageSizesConfig"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <!-- 删除弹窗 -->
    <el-dialog class="my-dialog" title="提示" :visible.sync="delDialogVisible">
      <span>文档删除后将不可查看或下载，确定删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="clickDelDoc">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传弹窗 -->
    <el-dialog
      class="my-dialog"
      :title="uploadDialogTitle"
      :visible.sync="uploadDialogVisible"
      width="600px"
      :before-close="handleCloseUploadDialog"
    >
      <el-dialog width="30%" title="提示" :visible.sync="closeTipsDialogVisible" append-to-body>
        <span>请确认是否中断上传此文档？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeTipsDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="clickInnerDialogConfirmBtn">确 定</el-button>
        </span>
      </el-dialog>
      <el-upload
        ref="upload"
        class="upload-demo"
        action=""
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        multiple
        :limit="10"
        :on-exceed="handleExceed"
        :show-file-list="false"
        :http-request="handleRequest"
      >
        <el-button v-if="!fileList.length" size="small" type="primary">选择文档</el-button>
        <div slot="tip" v-if="!fileList.length" class="el-upload__tip">可同时选择10个文档上传</div>
      </el-upload>
      <ul class="file-list-ul">
        <li v-for="(item, index) in fileList" :key="index" class="file-list-item">
          <div
            :class="{
              'file-content': true,
              'error-text': item.status === 'error',
            }"
          >
            <i
              :class="{
                'el-icon-success': item.status === 'success',
                'icon-success': item.status === 'success',
                'el-icon-warning': item.status === 'error',
                'icon-error': item.status === 'error',
                'el-icon-loading': item.status === 'loading',
                'icon-loading': item.status === 'loading',
              }"
            ></i>
            <span class="file-name">{{ item.fileName }}</span>
            <span class="progress">{{ (item.percent * 100).toFixed(2) }} %</span>
            <i
              class="el-icon-delete icon-delete"
              :style="{ visibility: item.status === 'success' ? 'hidden' : 'visible' }"
              @click="deleteUploadFile(item)"
            ></i>
          </div>
          <div
            :class="{
              'upload-progress': true,
              'error-progress': item.status === 'error',
            }"
            :style="{
              width: `${item.percent * 100}%`,
            }"
          ></div>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
import { CosMixin } from '@/mixins/cos';
import { downloadFileAction, bytesToSize, postfixFun } from '@/utils/util';
import NoData from '@/components/no-data';
import {
  GetDocList,
  DelDoc,
  GetDocTypeList,
  DownloadDoc,
  UploadDoc,
  RenameDoc,
} from '@/api/releaseManagement';
import cloneDeep from 'lodash/cloneDeep';
import { IMG_SRC } from '@/utils/constant';
const { docTypeImg } = IMG_SRC;
export default {
  name: 'Document',
  components: {
    NoData,
  },
  mixins: [CosMixin],
  data() {
    return {
      bytesToSize,
      delDialogVisible: false,
      uploadDialogVisible: false,
      closeTipsDialogVisible: false,
      fileList: [],
      docFormatOptions: [],
      formValue: {
        docName: '',
        docType: [],
      },
      pagination: {
        page_size: this.g_pageSizeDefault,
        page_index: 1,
      },
      total: 0,
      isLoading: false,
      dataList: [],
      statusMap: {
        1: '未上传',
        2: '已上传',
        3: '已删除',
      },
      orderBy: '-CTime', // 默认按上传时间倒序
      clickRow: null,
      cont: 0,
      abortSign: [{}],
    };
  },
  computed: {
    uploadDialogTitle() {
      if (this.fileList.some((item) => item.status === 'loading')) {
        return '正在上传，请勿关闭此弹窗或标签页';
      }
      return '上传文档';
    },
  },
  watch: {
    fileList: {
      handler(val) {
        if (val.length && val.every((item) => item.status === 'success')) {
          this.$message.success('上传成功');
          this.uploadDialogVisible = false;
          this.$refs.upload.clearFiles();
          this.fileList = [];
          this.cont = 0;
          this.getList();
        }
      },
      deep: true,
    },
  },
  created() {
    this.pagination.page_size = this.g_pageSizeDefault;
    this.getDocTypeOptions();
    this.getList();
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '' },
      {
        menu_name: '素材库管理',
        menu_path: '',
      },
      { menu_name: '文档' },
    ];

    this.$store.commit('user/setBreadcrumb', breadcrumb);
  },
  destroyed() {
    console.log('关闭前');
    this.handleListener('remove');
  },
  methods: {
    handleListener(type = 'add') {
      if (type === 'add') {
        window.addEventListener('beforeunload', this.beforeunloadHandler);
      } else {
        window.removeEventListener('beforeunload', this.beforeunloadHandler);
      }
    },
    beforeunloadHandler(e) {
      e = e || window.event;
      if (e) {
        console.log('e', e);
        e.returnValue = '关闭页面';
      }
      return '关闭页面';
    },
    mapDocType(row) {
      return docTypeImg[row.Type] || docTypeImg.default;
    },
    async getDocTypeOptions() {
      try {
        const res = await GetDocTypeList();
        console.log(res);
        this.docFormatOptions = res.TypeList.map((item) => ({
          label: item,
          value: item,
        }));
      } catch (err) {
        console.log('err', err);
      }
    },
    async getList() {
      this.isLoading = true;
      try {
        const res = await GetDocList({
          Name: this.formValue.docName,
          TypeList: this.formValue.docType,
          Req: {
            PageIndex: this.pagination.page_index,
            PageSize: this.pagination.page_size,
            OrderBy: this.orderBy,
          },
        });
        console.log(res);
        this.dataList = res.Records.map((item) => {
          const items = { ...item };
          const { prefix, postfix } = postfixFun(item.Name);
          items.prefix = prefix;
          items.postfix = postfix;
          items.show = false;
          return items;
        });
        this.total = res.Total;
        this.isLoading = false;
      } catch (err) {
        console.log('err', err);
        this.isLoading = false;
      }
    },
    updateDoc(row, actionType) {
      if (actionType === 'edit') {
        this.dataList = cloneDeep(this.dataList).map((item) => {
          const items = { ...item };
          if (item.Id === row.Id) {
            items.show = true;
          }
          return items;
        });
      }

      if (actionType === 'save') {
        this.updateDocName(row);
      }
    },
    async updateDocName(row) {
      try {
        const params = {
          Id: row.Id,
          Name: `${row.prefix}${row.postfix}`,
        };
        await RenameDoc(params);
        this.$message.success('保存成功');

        this.getList();
      } catch (err) {
        console.log(err);
        this.$message.error('保存失败');
      }
    },
    sortChange({ column, prop, order }) {
      console.log(column, prop, order);
      if (order === 'descending') {
        this.orderBy = '-Name';
      } else if (order === 'ascending') {
        this.orderBy = 'Name';
      } else {
        this.orderBy = '-CTime';
      }
      this.getList();
    },
    async clickDelDoc() {
      try {
        await DelDoc({
          Id: this.clickRow.Id,
          Channel: '管理端',
        });
        this.delDialogVisible = false;
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {
        console.log('err', err);
        this.$message.error('操作失败');
      }
    },
    // 点击上传文档
    clickUploadFileBtn() {
      this.uploadDialogVisible = true;
    },
    // 文件超出个数限制时的钩子
    handleExceed(fileList) {
      if (fileList.length > 10) {
        this.$message.warning('超出最大上传文件数');
      }
    },
    handleClickPreview() {},
    // 查看日志
    handleClickToDetail(row) {
      this.g_tourl(`/saas/materialManagement/docDetail.html?docId=${row.Id}`);
    },
    handleClickDownload(row) {
      if (this.statusMap[row.Status] === '已上传') {
        this.downloadFile(row);
      }
    },
    async downloadFile(row) {
      this.$message({
        message: '正在导出',
        iconClass: 'el-icon-loading',
      });
      try {
        const res = await DownloadDoc({
          Id: row.Id,
          Channel: '管理端',
        });
        const data = await downloadFileAction(res.Url, row.Name);
        if (data) {
          this.$message.success('导出成功');
        }
      } catch (err) {
        console.log(err);
        this.$message.error('导出失败');
      }
    },
    handleClickDelete(row) {
      this.clickRow = row;
      this.delDialogVisible = true;
    },
    handleCurrentChange(val) {
      this.pagination.page_index = val;
      this.getList();
    },
    handleSizeChange(size) {
      this.pagination.page_size = size;
      this.getList();
    },
    handlePreview() {},
    handleRemove(file) {
      console.log(file, 'handleRemove========>');
    },
    beforeRemove() {},
    async handleRequest(file) {
      this.handleListener('add');
      const fileConfig = {
        uid: file.file.uid,
        fileName: file.file.name,
        status: 'loading',
        percent: 0,
      };
      this.fileList.push(fileConfig);
      const { postfix } = postfixFun(file.file.name);
      try {
        const cosParams = {
          fileObject: file.file,
          suffix: postfix,
        };
        this.abortSign[file.file.uid] = { signal: false };
        const that = this;
        const res = await this.sliceCosObjectWithPrivate(
          cosParams,
          undefined,
          (progressData) => {
            fileConfig.percent = progressData.percent;
            console.log(fileConfig.percent);
            // console.log(that.abortSign);
          },
          that.abortSign[file.file.uid],
        );
        // const res = await this.putCosObjectWithPrivate(cosParams, undefined, (progressData) => {
        //   fileConfig.percent = progressData.percent;
        //   console.log(that.abortSign);
        // });
        // this.fileList[this.cont].percent = fileConfig.percent;
        // this.fileList[this.cont].status = 'success';
        // this.cont += 1;
        fileConfig.status = 'success';
        this.uploadDocData(res, fileConfig);
        this.handleListener('remove');
      } catch (err) {
        console.log('error', err);
        this.$message.warning(err.message);
        this.handleListener('remove');
        fileConfig.status = 'error';
      }
    },
    async uploadDocData(data, fileConfig) {
      const { fileObject } = data.origin;
      const { postfix } = postfixFun(fileObject.name);
      const params = {
        CTime: Math.round(new Date() / 1000),
        Name: fileObject.name,
        Type: postfix.slice(1),
        Size: fileObject.size,
        CosUrl: data.data,
        Status: 2,
        Code: data.key, // cos文档name
      };
      try {
        const res = await UploadDoc({
          Reqs: [params],
        });
        const id = res.Ids[0];
        for (const item of this.fileList) {
          if (item.uid === fileConfig.uid) {
            item.Id = id;
          }
        }
      } catch (err) {
        console.log('error', err);
      }
    },
    handleCloseUploadDialog() {
      // if (this.fileList.some((item) => item.status === 'loading')) {
      //   this.closeTipsDialogVisible = true;
      //   return;
      // }
      this.uploadDialogVisible = false;
    },
    clickInnerDialogConfirmBtn() {
      this.uploadDialogVisible = false;
      this.closeTipsDialogVisible = false;
      // 中断传输功能，sp9使用，勿删
      // const uids = this.fileList.map((item) => item.uid);
      // for (const uid of uids) {
      //   this.abortSign[uid].signal = true;
      // }
      // this.$refs.upload.clearFiles();
    },
    deleteUploadFile(row) {
      // 通过改变signal通知cos调用cancelTask
      const tempFunc = () => {
        this.abortSign[row.uid].signal = true;
        if (this.fileList.length === 1) {
          this.fileList = [];
          this.$refs.upload.clearFiles();
        } else {
          const index = this.fileList.findIndex((file) => file.uid === row.uid);
          this.fileList.splice(index, 1);
        }
      };
      if (row.status !== 'error') {
        this.$confirm('此操作将中断上传并删除文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          tempFunc();
        });
      } else {
        tempFunc();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.document-page {
  .filter-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    height: 68px;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .operation-area {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  .doc_type_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .my-dialog ::v-deep.el-dialog {
    .el-dialog__body {
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
    }
    .file-list-ul {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .file-list-item {
        background: #f7f9fc;
        height: 36px;
        width: 400px;
        margin-bottom: 10px;
        .file-content {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding-left: 16px;
          box-sizing: border-box;
          &.error-text {
            color: #f05942;
          }
          .icon-success {
            color: #76c84d;
          }
          .icon-error {
            color: #f05942;
          }
          .icon-loading {
            color: #2f96ff;
          }
          .file-name {
            flex: 1;
            width: 240px;
            text-align: left;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .icon-delete {
            color: grey;
            padding: 0 20px;
            cursor: pointer;
          }
        }
        .upload-progress {
          height: 2px;
          background: #2f96ff;
          box-sizing: border-box;
          &.error-progress {
            background: #f05942;
          }
        }
      }
    }
  }
}
</style>
